/* Umsatz-Sperre (30.10.2026): Der Server entscheidet, ob Umsatzzahlen herausgehen (backend/umsatz_sperre.py).
   Hier liegt nur der Freigabe-Token des Inhabers — in sessionStorage, 30 Minuten gültig, nie im Code oder in der URL.
   Der Axios-Client (lib/api.js) hängt ihn als Header X-Umsatz-Token an. Wer eine Zahl zeigt, die der Server mit
   null/umsatz_gesperrt liefern kann, nimmt <UmsatzWert/> aus components/UmsatzSperre.js. */

const KEY = 'p1_umsatz_freigabe';
const hoerer = new Set();

function lesen() {
  try {
    const roh = sessionStorage.getItem(KEY);
    if (!roh) return null;
    const f = JSON.parse(roh);
    if (!f || !f.token || !(f.bis > Date.now())) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return f;
  } catch {
    return null;
  }
}

export function getUmsatzToken() {
  return lesen()?.token || null;
}

export function getUmsatzBis() {
  return lesen()?.bis || null;
}

export function setUmsatzFreigabe(token, bisMs) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ token, bis: bisMs }));
  } catch { /* ohne Speicher bleibt alles verborgen */ }
  hoerer.forEach((f) => f());
}

export function loescheUmsatzFreigabe() {
  try { sessionStorage.removeItem(KEY); } catch { /* nichts zu tun */ }
  hoerer.forEach((f) => f());
}

export function beiUmsatzAenderung(fn) {
  hoerer.add(fn);
  return () => hoerer.delete(fn);
}

export const euroKurz = (v) => `${Number(v).toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €`;
